import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { store } from './redux';
import { theme } from './styles';
import { Spinner } from './components/ui-helpers';
import { AppRoutes } from './routes/route-container';

export default () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Suspense fallback={<Spinner />}>
        <AppRoutes />
      </Suspense>
    </ThemeProvider>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/app.js